export class ManageUser {
    public user: User
    public userTenantServices: UserTenantMap[];
    public userRoles: UserRoles[];
}
export class User {
    // Note: Using only optional constructor properties without backing store disables typescript's type checking for the type
    constructor(id?: string, userName?: string, fullName?: string, email?: string, jobTitle?: string, phoneNumber?: string, entityId?: number, entityName?: string, entityType?: string, tenantId?: number, currency?: string, roles?: string[], logo?: string) {

        this.id = id;
        this.userName = userName;
        this.fullName = fullName;
        this.email = email;
        this.jobTitle = jobTitle;
        this.phoneNumber = phoneNumber;
        this.roles = roles;

        this.entityId = entityId;
        this.entityName = entityName;
        this.entityType = entityType;
        this.tenantId = tenantId;
        // this.tenantCode = tenantCode;
        // this.userTenantMap = tenantMap;
        this.currency = currency;
        this.logo = logo;
    }


    get friendlyName(): string {
        let name = this.fullName || this.userName;

        if (this.jobTitle) {
            name = this.jobTitle + ' ' + name;
        }

        return name;
    }


    public id: string;
    public userName: string;
    public fullName: string;
    public email: string;
    public jobTitle: string;
    public phoneNumber: string;
    public isEnabled: boolean;
    public isLockedOut: boolean;
    public roles: string[];
    public serviceIds: number[];

    public entityId: number;
    public entityName: string;
    public entityType: string;
    public tenantId: number;
    // public tenantCode: string;
    // public userTenantMap: UserTenantMap[];
    public currency: string;
    public logo: string;

}
export class UserTenantMap {
    constructor() {
        this.tenantId = 0;
        this.serviceId = 0;
        this.defaultService = false;
        this.tenantName = "";
        this.tenantCode = "";

    }
    public tenantId: number;
    public serviceId: number;
    public defaultService: boolean;
    public tenantName: string;
    public tenantCode: string;
    deserialize(input: any): this {
        return Object.assign(this, input);
    }
}

export class UserRoles {
    public serviceId: number;
    public roleId: string;
    public roleName: string;
}